<div class="surface-section px-2 md:px-3 lg:px-4 text-center flex-auto">
    <div class="flex align-items-center justify-content-between">
        <span class="p-input-icon-left w-full">
            <i class="pi pi-search"></i>
            <input
                pInputText
                type="text"
                (input)="filteredSuscripcionByKeyword($event)"
                placeholder="{{appConfig.ux.searchRUCMsg}}"
                class="w-full"/>
        </span>
    </div>
</div>
<div class="surface-section px-2 md:px-3 lg:px-4 text-center">
    <div class="grid">
        <div class="surface-card border-round flex shadow-2 w-full" *ngFor="let plan of resultsFiltered" >
            <div class="bg-blue-50 flex align-items-center justify-content-center py-3 px-5">
                <strong>{{plan.organizacionName}}</strong>
            </div>
            <div class="py-3 px-5 flex flex-column align-items-start">
                <div class="text-900 font-medium mb-2 text-xl">Facturación electrónica</div>
                <p class="mt-0 mb-4 p-0 line-height-3">{{ plan.planName }} USD {{ plan.precio }}</p>
                <p class="mt-0 mb-4 p-0 line-height-2">Vigente desde: {{ plan.fechaInicio | date: 'yyyy/MM/dd' }}, hasta <strong>{{ plan.fechaFin | date: 'yyyy/MM/dd' }}</strong></p>
                <!--<button pButton pRipple label="Proceed" class="mt-auto"></button>-->
            </div>
            <div class="py-3 px-5 flex flex-column align-items-start">
                <div class="text-900 font-medium mb-2 text-xl">Firma electrónica</div>
                <p class="mt-0 mb-4 p-0 line-height-3">{{ plan.planTipoFirmaName == 'INDEFINIDO' ? 'Firma de otro proveedor' :  plan.planTipoFirmaName }}</p>
                <p class="mt-0 mb-4 p-0 line-height-2">Fecha de caducidad registrada: <strong>{{ plan.planTipoFirmaFechaFin | date: 'yyyy/MM/dd' }}</strong></p>
                <!--<button pButton pRipple label="Proceed" class="mt-auto"></button>-->
            </div>
        </div>
    </div>
    <div *ngIf="(!resultsFiltered || !resultsFiltered.length)"
         class="col-12 md:col-12 mb-1 p-6">
        <i *ngIf="!processFilter" class="pi pi-shopping-bag text-8xl"></i>
        <br>
        <strong *ngIf="!processFilter && (results && results.length)">{{appConfig.ux.emptyMsg}}</strong>
        <i *ngIf="processFilter" class="pi pi-spin pi-spinner text-8xl"></i>
    </div>  
</div>